<template>
  <b-modal id="action-modal" class="in-form-modal" size="lg" :title="mode === 'edit' ? 'ویرایش عملیات' : 'ثبت عملیات'"
    :ok-disabled="disabled" :cancel-disabled="disabled" :ok-title="mode === 'edit' ? 'ذخیره تغییرات' : 'ثبت'"
    cancel-title="لغو" @ok="submit" @hidden="onHidden">
    <form id="actionForm" autocomplete="off" @submit.prevent="submit">
      <div class="row">
        <b-form-group class="col-md-6">
          <label for="action-title">
            عنوان <i class="text-danger">*</i>
          </label>
          <b-form-input id="action-title" v-model.trim="action.title" maxlength="255" autocomplete="off"
            :state="fieldState('title')" @input="clearFieldError('title')" />
          <b-form-invalid-feedback>
            {{ errors.title }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="col-md-6">
          <label for="action-level">
            سطح <i class="text-danger">*</i>
          </label>
          <b-form-select id="action-level" v-model="action.level_id" :options="levelOptions"
            :state="fieldState('level_id')" @change="clearFieldError('level_id')">
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>
                سطح را انتخاب کنید
              </b-form-select-option>
            </template>
          </b-form-select>
          <b-form-invalid-feedback>
            {{ errors.level_id }}
          </b-form-invalid-feedback>
          <small v-if="!levelOptions.length" class="text-muted d-block mt-1">
            سطحی برای نمایش دریافت نشد.
          </small>
        </b-form-group>

        <b-form-group class="col-md-6">
          <label for="action-type">
            نوع عملیات <i class="text-danger">*</i>
          </label>
          <b-form-select id="action-type" v-model="action.type" :state="fieldState('type')" @change="handleTypeChange">
            <b-form-select-option value="free_shipping">
              ارسال رایگان
            </b-form-select-option>
            <b-form-select-option value="wallet_charge">
              شارژ کیف پول
            </b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback>
            {{ errors.type }}
          </b-form-invalid-feedback>
        </b-form-group>

        <!-- ارسال رایگان: حداقل مبلغ سبد خرید (ارسال به API با کلید type_value) -->
        <b-form-group v-if="isFreeShipping" class="col-md-6">
          <label for="action-min-order-amount">
            حداقل مبلغ سبد خرید (تومان)
          </label>
          <b-form-input id="action-min-order-amount" v-model="typeValueDisplay" :formatter="formatAmount" type="text"
            inputmode="numeric" dir="ltr" class="text-left" autocomplete="off" :state="fieldState('type_value')" />
          <b-form-invalid-feedback>
            {{ errors.type_value }}
          </b-form-invalid-feedback>
        </b-form-group>

        <!-- شارژ کیف پول: مبلغ شارژ -->
        <b-form-group v-else-if="isWalletCharge" class="col-md-6">
          <label for="action-type-value">
            مبلغ شارژ کیف پول <i class="text-danger">*</i>
          </label>
          <b-form-input id="action-type-value" v-model.number="action.type_value" type="number" inputmode="numeric"
            min="0" step="1" autocomplete="off" :state="fieldState('type_value')"
            @input="clearFieldError('type_value')" />
          <b-form-invalid-feedback>
            {{ errors.type_value }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group class="col-md-6">
          <label>
            تاریخ شروع <i class="text-danger">*</i>
          </label>
          <date-picker v-model="action.start_date" type="datetime" format="YYYY-MM-DD HH:mm"
            display-format="jYYYY-jMM-jDD HH:mm" @input="clearFieldError('start_date')" />
          <small v-if="errors.start_date" class="text-danger d-block mt-1">
            {{ errors.start_date }}
          </small>
        </b-form-group>

        <b-form-group class="col-md-6">
          <label>
            تاریخ پایان <i class="text-danger">*</i>
          </label>
          <date-picker v-model="action.end_date" type="datetime" format="YYYY-MM-DD HH:mm"
            display-format="jYYYY-jMM-jDD HH:mm" @input="clearFieldError('end_date')" />
          <small v-if="errors.end_date" class="text-danger d-block mt-1">
            {{ errors.end_date }}
          </small>
        </b-form-group>
      </div>
    </form>
  </b-modal>
</template>

<script>
import ActionFormImpl from "@@/core/components/action/ActionForm/ActionFormImpl";

export default {
  extends: ActionFormImpl,
};
</script>